<div class="payment-container">
  <div *ngIf="loading" class="loading-state">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Processing your payment...</p>
  </div>

  <div *ngIf="!loading" class="result-container">
    <div *ngIf="paymentStatus === 'success'" class="success-state">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h2>Payment Successful!</h2>
      <p>Thank you for your payment. Your transaction has been completed.</p>
      
      <div *ngIf="transactionDetails" class="transaction-details">
        <h3>Transaction Details</h3>
        <p><strong>Amount:</strong> {{transactionDetails.amount | currency:'CAD'}}</p>
        <p><strong>Transaction ID:</strong> {{transactionDetails.transId}}</p>
        <p><strong>Date:</strong> {{transactionDetails.timestamp | date:'medium'}}</p>
      </div>

      <button mat-raised-button color="primary" routerLink="/dashboard">
        Return to Dashboard
      </button>
    </div>

    <div *ngIf="paymentStatus === 'failed'" class="error-state">
      <mat-icon class="error-icon">error</mat-icon>
      <h2>Payment Failed</h2>
      <p>{{errorMessage || 'There was an issue processing your payment.'}}</p>
      
      <button mat-raised-button color="warn" routerLink="/payment-receipt">
        Try Payment Again
      </button>
      <button mat-button routerLink="/contact-us">
        Contact Support
      </button>
    </div>
  </div>
</div>